module.exports = __webpack_public_path__ + "img/dtjbig.e6d39e46.png";